import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import SolutionCard from "./SolutionCard";
const SolutionCardPreview = () => {
    return (_jsx(SolutionCard, { label: "Label", title: "Titre du bloc", question: "Question principale", description: "Description du contenu avec d\u00E9tails suppl\u00E9mentaires", buttonText: "D\u00E9couvrir", buttonLink: "#" }));
};
export default SolutionCardPreview;
